import React from 'react';
import Button from 'react-bootstrap/Button';
import Modal from 'react-bootstrap/Modal';
import { connect } from 'react-redux';
import { useDispatch } from 'react-redux';
import { hideModal } from '../../store/actions/index';
import { useForm } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

const ProjectSolutionMetadataModal = (props) => {

  const dispatch = useDispatch();
  const { t } = useTranslation();
  const { register, errors, handleSubmit } = useForm();

  const onSubmit = data => {
    dispatch( props.onSubmitAction(data) ).then( dispatch(hideModal()) );
  }

  const initialValues = props.initialValues

  const errorMessage = (errors, fieldName) => {
    return (errors[fieldName] !== undefined)?
       <div className="invalid-feedback">
          { t('modal.solution_metadata.form.' + fieldName + '.' + errors[fieldName]['type']) }
        </div> : null
  }

  const isItValid = (errors, fieldName) => {
    return (errors[fieldName] !== undefined)? "is-invalid" : ""
  }

  return (
   	<Modal show={true} onHide={props.hideModal} animation={true}>
   		<div className="modal-header">
   			<h5 className="modal-title">{props.modalTitle}</h5>
   			<button type="button" onClick={props.hideModal} className="close btn btn-round" data-dismiss="modal" aria-label="Close"> <i className="material-icons">close</i>
   			</button>
   		</div>
   		<Modal.Body>
        <form onSubmit={handleSubmit(onSubmit)}>
          <div className="form-group">
  						<label htmlFor="description" className="col-form-label">{ t( 'modal.product_solution_meta_data.form.description.label' ) }</label>
            <textarea
              name="description"
              rows="1"
              defaultValue={initialValues.description}
              className={"form-control " + isItValid(errors, 'description') }
              ref={register({maxLength: 60})}
            />
            { errors.description && errors.description.type === "maxLength" &&
             (errorMessage(errors, 'description'))
            }
          </div>
          <div className="form-group">
  				  <label htmlFor="notice" className="col-form-label">{ t( 'modal.product_solution_meta_data.form.notice.label' ) }</label>
            <textarea
              name="notice"
              rows="3"
              defaultValue={initialValues.notice}
              className="form-control"
              ref={register({maxLength: 100})} />
          </div>

        </form>
   		</Modal.Body>
   		<Modal.Footer>
   			<Button variant="secondary" onClick={props.hideModal}>{t( 'modals.common.button.close' )}</Button>
   			<button type="submit" onClick={handleSubmit(onSubmit)} className="btn btn-primary">{ t( 'modals.common.button.save' ) }</button>
   		</Modal.Footer>
   	</Modal>
  )
}

const mapDispatchToProps = dispatch => ({
  hideModal: () => dispatch(hideModal())
})

export default connect(null, mapDispatchToProps)(ProjectSolutionMetadataModal)



// WEBPACK FOOTER //
// ./src/components/Modals/ProjectSolutionMetadataModal.js